import { render } from "./TestUCEmptyList.vue?vue&type=template&id=8e38b34a"
import script from "./TestUCEmptyList.vue?vue&type=script&lang=js"
export * from "./TestUCEmptyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__